// Magic link validity window. Kept short to limit the blast radius of a leaked
// inbox while staying long enough for a user to switch to their email and click
// through. Import-free so the sign-in forms can show the same label the server
// enforces.
export const MAGIC_LINK_EXPIRES_IN_SECONDS = 10 * 60;
export const MAGIC_LINK_EXPIRES_IN_LABEL = "10 minutes";

// The query params the signed referral handoff adds to a magic link
// (withMagicLinkReferral in signup-referral.ts). Here, import-free, because the
// page the emailed link opens has to forward them without loading that module.
export const REFERRAL_TOKEN_PARAM = "signup_referral";
export const REFERRAL_PROOF_PARAM = "signup_referral_proof";
